export const ANALYTICS_EVENT_TYPE = {
    PLAY: 1,
    PAUSE: 2,
    SEEKED: 3,
    COMPLETE: 4,
};
